export default "__VITE_ASSET__c5ba2e41__"